module.exports = __webpack_public_path__ + "img/header-1.a2a6e05f.png";